import React, {useRef, useEffect} from "react";

import 'zingchart/es6';
import ZingChart from 'zingchart-react';
// EXPLICITLY IMPORT MODULE
// import 'zingchart-react/dist/modules-es6/zingchart-depth.min.js';
import "./gauge.css";
import { CropLandscapeOutlined } from "@material-ui/icons";

export const Gauge = (props) => {
  const zingChart = useRef(null);

//props will be passed which includes the value to be put in the gauge chart

//establishing RULES AND LABELS
//init labels
var labelsForSectionNames = [''];
var labelsForPercentages = [];
var labelsSPACES = 0;

//init rules
var rulesForIndices = [];
var rulesForMainColour = [];
var rulesForSecondaryColour = [];
var rulesforScore = [];

for (var j=0; j<=100; j++){
  rulesForIndices.push({
    rule: '%i == ' + j.toString(),
    visible: false
  });
  labelsForPercentages.push(j.toString() + "%");
}

for (var eachCategory in props.data.sections) {
  var category = props.data.sections[eachCategory];
  var percentage = category.upperLimit - category.lowerLimit;
  //LABELS

  //label 1 - categorty names
  var nameOfCategoryCharacters = eachCategory.split("");

  if (nameOfCategoryCharacters.length > percentage - 2){ //i.e. we have 10 spaces and "Outstanding" has 11 letters

    while (nameOfCategoryCharacters.length > percentage - 2){
      nameOfCategoryCharacters.pop();
    }
    nameOfCategoryCharacters[nameOfCategoryCharacters.length - 1] = '.';
    nameOfCategoryCharacters[nameOfCategoryCharacters.length - 2] = '.';
  } 
  
  labelsSPACES = percentage - nameOfCategoryCharacters.length;
  var sizeToFillIn = Math.floor(labelsSPACES /2);
  labelsForSectionNames = labelsForSectionNames.concat(Array(sizeToFillIn).fill(""));
  labelsForSectionNames = labelsForSectionNames.concat(nameOfCategoryCharacters);
  if (sizeToFillIn* 2 !== labelsSPACES) sizeToFillIn++;
  labelsForSectionNames = labelsForSectionNames.concat(Array(sizeToFillIn).fill("")); 

   //RULES
   
   //rules 1 - main colour
  rulesForMainColour.push({
    rule: '%v < ' + category.upperLimit.toString() + ' && %v >= ' + category.lowerLimit.toString(),
    backgroundColor: category.style.themeBackground,
    alpha: 1
  });

  //rules 2 - colour for names of sections 
  rulesForSecondaryColour.push({
    rule: '%v < ' + category.upperLimit.toString() + ' && %v >= ' + category.lowerLimit.toString(),
    backgroundColor: category.style.themeBackground,
    alpha: 1
  });
  
  //rules 3 - summarising score
  rulesforScore.push({
    rule: '%v <= ' + category.upperLimit.toString() + ' && %v > ' + category.lowerLimit.toString(),
    text: '<br><br><br><br><br><br>' + props.data.year.toString() + ' SCORE<br>%v% ' + eachCategory
  });

  //rules 4 - visibility of ticks
   rulesForIndices[category.upperLimit] = {
      rule: '%i == ' + category.upperLimit,
      visible: true,
    };

   
}
labelsForSectionNames.push('');
rulesForIndices[0] = {
  rule: '%i == 0',
  visible: true
};


  var myConfig = {
    type: "gauge",
    globals: {
      fontSize: 25
    },
    plotarea: {
      marginTop: 80
    },
    plot: {
      size: '95%',
      valueBox: {
        placement: 'center',
        text: '%v',
        fontSize: 25,
        rules: rulesforScore
      }
    },
    tooltip: {
      borderRadius: 5,
      backgroundColor :"white",
      fontColor: "black",
      fontSize: 10,
      padding:"5 10",
      borderColor:"gray",
      borderWidth:1,
      text: "Value: %v%",
    },
    scaleR: {
      aperture: 180,
      minValue: 0,
      maxValue: 100,
      maxTicks: 200,
      step: 1,
      center: {
        visible: true,
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      tick: {
        visible: false,
      },
      item: {
        visible: false
      },
      maxItems: 0,
      ring: {
        size: 50,
        rules: rulesForMainColour,
      },
    },
    scaleR2: { // Scale for names of sections
      aperture: 180,
      minValue: 0,
      maxValue: 100,
      maxTicks: 100,
      step: 1,
      center: {
        visible: true,
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      tick: {
        visible: false
      },
      item: {
        fontSize: 15,
        fontColor: "white",
        fontWeight: "bold",
        angle: "auto",
        fontFamily : "Inconsolata",
        offsetR: -23
      },
      maxItems: 101,
      labels: labelsForSectionNames,
      ring: {
        size: 20,
        rules: rulesForSecondaryColour
      },
      guide: {
        alpha: 0 //Make sure your larger scale's background is set to transparent.
      }
    },
    scaleR3: { //scale for labels at the top (mutatable)
      aperture: 180,
      minValue: 0,
      maxValue: 100,
      maxTicks: 20,
      step: 1,
      // values: "0:100:10",
      center: {
        visible: true,
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      ring: {
        visible: false
      },
      tick: {
        visible: false,
      },
      item: {
        offsetR: -30,
        fontSize: 14,
        fontColor: "black",
        fontFamily : "Inconsolata",
        angle: "auto",
        rules: rulesForIndices,
      },
      maxItems: 101,
      labels: labelsForPercentages,
    },
    scaleR4: { //scale which consists of long ticks to mark every 10 points
      aperture: 180,
      minValue: 0,
      maxValue: 100,
      maxTicks: 20,
      step: 10,
      center: {
        visible: true,
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      ring: {
        visible: false
      },
      minorTicks: 1,
      minorTick: {
        lineColor: "white",
        lineStyle: "solid",
        lineWidth: 2,
        size: 10,
        placement: "inner"
      },
      tick: {
        visible: true,
        lineColor: "white",
        lineStyle: "solid",
        lineWidth: 2.9,
        size: 52,
        placement: "inner",
        alpha: 1.0,
      },
      item: {
        visible: false
      },
      maxItems: 0,
    },
    scaleR5: { //scale which consists of just 2 ticks (beginning and end)
      aperture: 180,
      minValue: 0,
      maxValue: 100,
      maxTicks: 2,
      step: 180,
      center: {
        visible: true,
        borderColor: "#6d6968",
        borderWidth: "0.9",
      },
      ring: {
        visible: false
      },
      tick: {
        visible: true,
        lineColor: "white",
        lineStyle: "solid",
        lineWidth: 2.9,
        size: 21,
        placement: "inner",
        alpha: 1.0,
      },
      item: {
        visible: false
      },
      maxItems: 0,
    },
    refresh: {
      type: "feed",
      transport: "js",
      url: "feed()",
      interval: 1500,
      resetTimeout: 1000
    },
    series: [{
      values: [props.data.value], // starting value
      backgroundColor: '#6d6968',
      indicator: [30, -10, 30, 30, 1.0],
      // animation: {
      //   effect: 2,
      //   method: 1,
      //   sequence: 4,
      //   speed: 900
      // },
    }],
    scale : {
      sizeFactor: 1.09
    },
    scale2: {
      sizeFactor: 1.21
    },
    scale3: {
      sizeFactor: 1.33
    },
    scale4: {
      sizeFactor: 1.09
    },
    scale5: {
      sizeFactor: 1.21
    },
  };
  useEffect(()=>{
    if(props.imageReturn && zingChart){
      if(zingChart.current){
        props.setDiagramImage(zingChart.current.getimagedata());
      }
    }

  },[])
  useEffect(()=>{
    if(props.imageReturn && zingChart){
      if(zingChart.current){
        props.setDiagramImage(zingChart.current.getimagedata());
      }
    }

  },[props.imageReturn])
  return (
    <div>
      <ZingChart output="canvas" ref={zingChart} data={myConfig}/>
    </div>
  );
};

